import React, { memo, useMemo, useCallback, useState, useRef } from 'react';
import classnames from 'classnames';
import { createUseStyles, Text, Icon, Checkbox, Menus, Tooltip } from 'hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'WidgetHeader');
var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "moreHoriz"
});
const Header = /*#__PURE__*/memo(_ref => {
  let {
    title,
    isSelected,
    onSelect,
    actions,
    menuItems,
    isLoaded
  } = _ref;
  const classes = useStyles();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const ref = useRef(null);
  const stopPropagation = useCallback(e => {
    var _e$stopPropagation;
    e === null || e === void 0 ? void 0 : (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 ? void 0 : _e$stopPropagation.call(e);
  }, []);
  const overridesIcon = useMemo(() => ({
    root: {
      onMouseDown: stopPropagation
    }
  }), [stopPropagation]);
  const getPopupContainer = useCallback(() => {
    if (ref.current) return ref.current;
    return null;
  }, []);
  const overridesMenu = useMemo(() => ({
    root: {
      onMouseDown: stopPropagation
    },
    'rc-menu': {
      onOpenChange: items => setIsMenuOpen(items.length > 0),
      getPopupContainer
    },
    'rc-menu-sub-menu': {
      popupPlacement: 'bottomLeft'
    }
  }), [stopPropagation, getPopupContainer]);
  const renderActions = useMemo(() => {
    if (!(actions !== null && actions !== void 0 && actions.length)) return null;
    let iconActions = [];
    actions.forEach((current, index) => {
      const {
        title,
        iconName,
        onClick
      } = current;
      if (title) {
        iconActions.push(/*#__PURE__*/React.createElement(Icon, {
          key: index,
          name: iconName,
          onClick: onClick,
          overrides: overridesIcon,
          tooltip: title
        }));
      } else {
        iconActions.push(/*#__PURE__*/React.createElement(Icon, {
          key: index,
          name: iconName,
          onClick: onClick,
          overrides: overridesIcon,
          tooltip: title
        }));
      }
    });
    return iconActions;
  }, [actions, overridesIcon]);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.root, {
      [classes.isSelected]: isSelected || false
    }),
    ref: ref
  }, isLoaded && onSelect && /*#__PURE__*/React.createElement("div", {
    className: classes.selector
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: isSelected,
    onChange: onSelect,
    color: "actionMajor",
    overrides: overridesIcon
  })), title && /*#__PURE__*/React.createElement(Tooltip, {
    content: title
  }, /*#__PURE__*/React.createElement(Text, {
    className: classes.title,
    size: "big",
    type: "h6",
    isTruncated: true
  }, title)), isLoaded && ((actions === null || actions === void 0 ? void 0 : actions.length) > 0 || (menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) > 0) && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.actions, {
      [classes.noActions]: isSelected || false,
      [classes.menuOpen]: isMenuOpen || false
    })
  }, renderActions, (menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) > 0 && /*#__PURE__*/React.createElement(Menus, {
    icon: _ref2,
    items: menuItems,
    overrides: overridesMenu,
    triggerAction: "hover",
    classNameMenu: classes.menuPopover
  })));
});
export default Header;